import { ApplicationConfig, provideZoneChangeDetection, ErrorHandler, importProvidersFrom, provideAppInitializer, inject } from '@angular/core';
import { provideRouter, withPreloading } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideIonicAngular } from '@ionic/angular/standalone';
import { RecaptchaFormsModule, RecaptchaModule } from 'ng-recaptcha-2';
import { initializeApp, getApps } from 'firebase/app';

import { routes } from './app.routes';
import { sessionInterceptor } from './interceptors/session.interceptor';
import { authInterceptor } from './interceptors/auth.interceptor';
import { connectionErrorInterceptor } from './interceptors/connection-error.interceptor';
import { guestAuthInterceptor } from './interceptors/guest-auth.interceptor';
import { AuthStateService } from './services/auth-state.service';
import { ChunkLoadingErrorHandlerService } from './services/chunk-loading-error-handler.service';
import { HomePreloadStrategy } from './strategies/home-preload.strategy';
import { StorageService } from './services/storage.service';
import { environment } from '../environments/environment';

// PE-6139 — initialize Firebase before modular auth (getAuth) is used on sign-up
if (!getApps().length) {
  initializeApp(environment.firebaseConfig);
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }), 
    provideRouter(
      routes,
      withPreloading(HomePreloadStrategy)
    ),
    // PE-00 — hydrate Web Crypto AES-GCM storage cache before guards/interceptors run
    provideAppInitializer(() => {
      const storage = inject(StorageService);
      return storage.hydrateFromBrowserStorage();
    }),
    // PE-6155 — connectionErrorInterceptor toasts all HTTP errors via resolveHttpErrorMessage
    provideHttpClient(withInterceptors([sessionInterceptor, authInterceptor, connectionErrorInterceptor])),
    // PE-6139 — guest Bearer before session interceptor; sessionid path unchanged when logged in
    provideHttpClient(withInterceptors([guestAuthInterceptor, sessionInterceptor, authInterceptor])),
    provideAnimations(),
    provideIonicAngular({}),
    AuthStateService,
    HomePreloadStrategy,
    { provide: ErrorHandler, useClass: ChunkLoadingErrorHandlerService },
    importProvidersFrom(RecaptchaModule, RecaptchaFormsModule),
  ]
};
